import React, { FC, Fragment } from "react";
import { FormControl, RadioGroup, Grid, makeStyles, createStyles } from "@material-ui/core";
import { useStyles } from "../../useStyles";
import { useFormModel } from "../core/FormModelHelpes";
import { ChangeNames, ChangeTypes } from "../../clients/FirebaseClient/types";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";
import { InfoBoxNewConnectionMultilineCellarCasingPipeDeliveredByDistributionSystemOperator } from "../core/InfoBox";

const useFormControlStyles = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        firstFormControlLabelStyle: {
            marginRight: 48,
        },
        secondFormControlLabelStyle: {
            marginRight: 75,
        },
    }),
);

const convertValue = (
    value: ChangeTypes[ChangeNames.NEW_CONNECTION_MULTILINE_INSTALLATION_FRAME_INSTALLED_BY_DISTRIBUTION_SYSTEM_OPERATOR]["value"],
): string => {
    if (value.yes) return "yes";
    if (value.no) return "no";
    return "";
};

export const NewConnectionMultilineCellarCasingPipeDeliveredByDistributionSystemOperatorForm: FC = () => {
    const classes = useStyles();
    const formControlStyles = useFormControlStyles();

    const { values, setValues } = useFormModel<
        ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_CASING_PIPE_DELIVERED_BY_DISTRIBUTION_SYSTEM_OPERATOR
    >();

    const selection = convertValue(
        values.newConnectionMultilineCellarCasingPipeDeliveredByDistributionSystemOperator.value,
    );

    return (
        <Fragment>
            <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                Futterrohr
            </h4>
            <p className={classes.p} style={{ marginBottom: 0, marginTop: 16 }}>
                Anhand Ihrer Auswahl ist ein Futterrohr für die Mehrspartenausführung notwendig.
                Bitte geben Sie an, von wem Sie das Futterrohr beziehen möchten.
            </p>
            <InfoBoxNewConnectionMultilineCellarCasingPipeDeliveredByDistributionSystemOperator />
            <FormControl component="fieldset" style={{ display: "flex" }}>
                <RadioGroup
                    value={selection}
                    onChange={(e, v) => {
                        setValues(values => {
                            values.newConnectionMultilineCellarCasingPipeDeliveredByDistributionSystemOperator.value = {
                                yes: v.includes("yes"),
                                no: v.includes("no"),
                            };
                        });
                    }}
                >
                    <Grid container spacing={7} className={formControlStyles.container}>
                        <Grid item xs={8} sm={12} md={12}>
                            <FormControlLabel
                                value="yes"
                                control={<Radio />}
                                label="Lieferung durch Syna"
                                error={
                                    values
                                        .newConnectionMultilineCellarCasingPipeDeliveredByDistributionSystemOperator
                                        .error !== null
                                }
                            />
                            <FormControlLabel
                                value="no"
                                control={<Radio />}
                                label="Eigenes Futterrohr"
                                error={
                                    values
                                        .newConnectionMultilineCellarCasingPipeDeliveredByDistributionSystemOperator
                                        .error !== null
                                }
                            />
                        </Grid>
                    </Grid>
                </RadioGroup>
            </FormControl>
        </Fragment>
    );
};
